import { Chip, styled } from "@mui/material"
import React from "react";
import StatusColor from "../../common/Utils/StatusColor/StatusColor";
import { tag } from "../../theme/tokens/component/tag";

export const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => !['badgeSize', 'bold', 'status'].includes(prop),
})(({ theme, status, bold, badgeSize = 'lg', color }) => {
    const statusColors = StatusColor(status, bold);
    const sizeStyles = {
      sm: {
        height:   tag.size.badge.height.sm,    // 14px
        minWidth: tag.size.badge.minWidth.sm,  // 16px
        paddingX: theme.spacing('tiny'),       // 4px
        paddingY: theme.spacing(0.5),          // 2px
        fontSize: '0.66rem',                   // 10.56px TODO: replace when added to typography tokens
      },
      md: {
        height:   tag.size.badge.height.md,    // 18px
        minWidth: tag.size.badge.minWidth.md,  // 24px
        paddingX: theme.spacing(1.5),          // 6px - doesn't exist in spacing tokens
        paddingY: theme.spacing('tiny'),       // 4px
      },
      lg: {
        height:   tag.size.badge.height.lg,    // 20px
        minWidth: tag.size.badge.minWidth.lg,  // 32px
        paddingX: theme.spacing('xxs'),        // 8px
        paddingY: theme.spacing('tiny'),       // 4px
      },
    };
    const sizeStyle = sizeStyles[badgeSize] ?? sizeStyles.md;
    
    return {
        '&&': {
            ...(!color && {
                backgroundColor: statusColors.bg,
                color: statusColors.text,
            }),
            ...(color === 'default' && {
                backgroundColor: theme.palette.grey[600],
                color: theme.palette.common.white,
            }),
            borderRadius: theme.radius.full,
            height: sizeStyle.height,
            minWidth: sizeStyle.minWidth,
            paddingTop: sizeStyle.paddingY,
            paddingBottom: sizeStyle.paddingY,
            paddingLeft: 0,
            paddingRight: 0,
            gap: 0,
            fontWeight: theme.typography.fontWeightRegular,
            '& .MuiChip-label': {
                margin: 0,
                paddingLeft: sizeStyle.paddingX,
                paddingRight: sizeStyle.paddingX,
                lineHeight: 1,
                fontSize: sizeStyle.fontSize ?? theme.typography.body1.fontSize,
            },
        },
    };
});

const StatusBadge = React.forwardRef(({ status, bold = false, size = 'lg', ...props }, ref) => {
    return (
        <StyledChip
            ref={ref}
            label={status}
            status={status}
            bold={bold}
            badgeSize={size}
            {...props}
        />
    )
});

export default StatusBadge